import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.primary,
      display: 'flex',
      gap: '10px',
      alignItems: 'start',
      fontSize: '14px',
      height: '70px',
      cursor: 'pointer'
    },
    profile: {
      backgroundColor: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      padding: '5px',
      fontSize: '19px',
      alignItems: 'center'
    },
    line1: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      wordBreak: 'break-all',
      '@media (min-width: 720px)': {
        '&>:nth-child(1)': {
          display: 'none'
        }
      },
      '@media (min-width: 1550px)': {
        '&>:nth-child(1)': {
          display: 'block'
        }
      }
    },
    divInfos: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    infos: {
      fontWeight: 700,
      margin: 0
    },
    ville: {
      fontWeight: 400,
      margin: 0
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
